// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageTabs_wrapper__229Ts","tab_item":"PageTabs_tab_item__Thed4"};